module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10028.b32512fb.jpg";